module.exports = __webpack_public_path__ + "img/searching-1.8abc858f.png";